import gql from 'graphql-tag';
import { UTILITY_CREDENTIAL_FRAGMENT } from '../utility-sync.api';

export const GET_UTILITY_SYNC_EDIT_DATA = gql`
  query GetUtilitySyncEditData($utilityCredentialId: Int!) {
    utilityCredential(id: $utilityCredentialId) {
      ...UtilityCredentialData
    }
  }
  ${UTILITY_CREDENTIAL_FRAGMENT}
`;

export const getUtilitySyncEditDataMock = {
  utilityCredential: {
    id: 1,
    __typename: 'UtilityCredential',
    username: 'mylogin',
    verificationStatus: 'incorrect',
    utility: {
      id: 2,
      displayName: 'Ameren',
      overrideEmailIsUsername: false,
    },
  },
};
